import {
  createActionGroup,
  emptyProps,
  props,
  createAction,
} from '@ngrx/store';
import { KeheManageProgressItem } from '@kehe/phoenix-top-bar';

export const ManagePromotionsActions = createActionGroup({
  source: 'Manage Promotions',
  events: {
    'Trigger Manage Progress': emptyProps(),
  },
});

// Renaming of this action would break the code, this needs to be the same as the action in
// libs\shared\phoenix\ui\top-bar\src\lib\phoenix-manage-progress-panel\store\manage-progress.actions.ts within phoenix repo
export const panelItemStatusChanged = createAction(
  '[Phoenix Manage Progress Panel] Panel Items Status Changed',
  props<{ changedItems: KeheManageProgressItem[] }>(),
);
